/**
 * Badge - registration.
 *
 * @package BrandyBlocks
 */

import { registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import Edit from './edit';
import Save from './save';
import './style.scss';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
				fill="currentColor"
			>
				<path d="M3 7.5A2.5 2.5 0 0 1 5.5 5h13A2.5 2.5 0 0 1 21 7.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 16.5v-9Zm2.5-.8a.8.8 0 0 0-.8.8v9c0 .44.36.8.8.8h13a.8.8 0 0 0 .8-.8v-9a.8.8 0 0 0-.8-.8h-13Z" />
				<circle cx="8" cy="12" r="1.6" />
				<rect x="11.5" y="11.1" width="7" height="1.8" rx="0.9" />
			</svg>
		),
	},
} );
